import React, { useState, useEffect } from "react";
import { useForm, useFieldArray } from "react-hook-form";
import { Link } from "react-router-dom";
import { DatePicker } from "antd";
import Select from "react-select";
import {
  Check,
  Plus,
  RotateCcw,
  Trash2,
} from "feather-icons-react/build/IconComponents";
import "../../style/css/sales-invoice-terminal.css";
import {
  useTerminalChrome,
  TermCmdBar,
  TermColumns,
  TermStatusBar,
} from "../transactions/terminal/TerminalChrome";
import { useSelector } from "react-redux";
import {
  addEditSales,
  getSalesByTransType,
} from "../../services/SalesApiServices";
import { Controller } from "react-hook-form";
import dayjs from "dayjs";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import CustomerModal from "../master/modal/CustomerModal";
import { Journalentry } from "../../core/json/JournalEntry";
import { journalDetails } from "../../core/json/JournalDetails";
import { FinancialYear } from "../../core/json/FinancialYear";
import {
  getJournal,
  savejournalentry,
} from "../../services/AccountApiServices";

const JournalEntryModal = ({ mode, data, handleClose, handleRefresh }) => {
  const {
    register,
    setValue,
    getValues,
    handleSubmit,
    watch,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      deliveryDate: dayjs().format("YYYY-MM-DD"),
      invdate: dayjs().format("YYYY-MM-DD"),
      addition: 0,
      subtraction: 0,
      round: 0,
    },
    mode: "onBlur",
  });
  const { fields, append, remove } = useFieldArray({
    control,
    name: "items",
  });
  const dispatch = useDispatch();
  const [modalOpen, setModalOpen] = useState(false);
  const [isRowAdded, setIsRowAdded] = useState(false);
  // const [totalDebit, setTotalDebit] = useState(0);
  // const [totalCredit, setTotalCredit] = useState(0);
  const { userId } = useSelector((state) => state.userauth);
  const { branch } = useSelector((state) => state.branchlist);
  const { formatedLedger } = useSelector((state) => state.ledger);
    const { companyInfolist } = useSelector((state) => state.companyInfo);
    const { branchsettings } = useSelector((state) => state.settings);

  const [loading, setloading] = useState(false);
  // Fetch sales quotations data
  const handleEntryNo = async () => {
    try {
      const response = await getJournal(branch);
      const receiptData = Array.isArray(response.data) ? response.data : [];
      // Find the maximum number from the existing entries
      const maxEntryNumber =
        receiptData?.length > 0
          ? receiptData
              ?.map((data) => parseInt(data.no))
              ?.reduce((max, num) => Math.max(max, num), 0) // Find the maximum number
          : 0;
      let counter = maxEntryNumber + 1;
      setValue(`no`, counter);
      counter++;
    } catch (error) {
      console.error("Failed to fetch journal entries", error);
    }
  };
  // useEffect(() => {
  //   resetmodal();
  // }, [data, append, remove]);

    useEffect(() => {
  if (mode === "edit") {
    resetmodal();
  }
}, [data]);

  function resetmodal() {
    if (mode === "edit" && data) {
      setValue("remark", data.narration);
      setValue("no", data.no);
      setValue("invdate", dayjs(data.date));
    }
    setValue(
      "items",
      data?.journalDetails?.map((detail, i) => ({
        ledger: detail.ledgerID || "Unknown Ledger",
        debit: detail.debit || 0.0,
        credit: detail.credit || 0.0,
        narration: detail.narration,
      }))
    );
  }

  useEffect(() => {
    const fetchData = async () => {
      if (mode === "add") {
        handleEntryNo();
        if (!isRowAdded && fields?.length === 0) {
          handleAddRow();
          setIsRowAdded(true);
        }
      }
    };

    fetchData();
  }, []);

  const handleAddRow = () => {
    append({
      debit: "0",
      credit: "0",
      narration: "",
      ledger: "",
    });
  };
  const handleFormSubmit = async (formData) => {
    if (totalCredit == totalDebit) {
      setloading(true);
      const objjournal = new Journalentry();
      const objfinance = new FinancialYear();
      objjournal.date = dayjs(formData.invdate).format("YYYY-MM-DD");
      objjournal.no = formData.no;
      objjournal.id = mode == "edit" ? data.id : 0;
      objjournal.guid = mode == "edit" ? data.guid : "";
      objjournal.narration = formData.remark;
      objjournal.branch = branch;
      objjournal.financialYear = objfinance;
           objfinance.id = branchsettings?.defaultFinancialYearID;
      objjournal.company = companyInfolist[0];
      objjournal.createdUser = userId.id;
      objjournal.updatedUser = userId.id;

      for (const row of formData.items) {
        const objdetail = new journalDetails();

        objdetail.ledgerID = row.ledger;
        objdetail.credit = Number(row.credit);
        objdetail.debit = Number(row.debit);
        objdetail.narration = row.narration;

        objjournal.journalDetails.push(objdetail);
      }

      try {
        const response = await savejournalentry(objjournal);
        if (response?.data === true) {
          toast.success("Success");
          handleRefresh();
          handleClose();
        } else {
          toast.error(response?.data?.Message || "Journal was not saved");
        }
        setloading(false);
      } catch (error) {
        toast.error(error?.response?.data?.Message || "something went wrong");
        console.error(
          "Error handling journal:",
          error?.response?.data?.Message
        );
        setloading(false);
      }
    } else {
      toast.error("Credit and Debit should be equal");
    }
  };
  //Calculations
  const totalDebit = fields?.reduce(
    (sum, _, index) => sum + parseFloat(watch(`items[${index}].debit`) || 0),
    0
  );
  const totalCredit = fields?.reduce(
    (sum, _, index) => sum + parseFloat(watch(`items[${index}].credit`) || 0),
    0
  );
  const balanceClass =
    totalDebit == 0 && totalCredit == 0
      ? "text-center border-2" // Set to black if both are zero
      : totalDebit === totalCredit
      ? "text-center text-success border-2" // Set to green if they match and are not zero
      : "text-center text-danger border-2";
  // react-select menus render into this node inside .si-term, so they pick
  // up the terminal's colour tokens like everything else
  const [menuHost, setMenuHost] = useState(null);
  const siSelectStyles = {
    menuPortal: (base) => ({ ...base, zIndex: 11000 }),
    menu: (base) => ({ ...base, zIndex: 11000 }),
  };

  // view preferences only - theme, full screen
  const chrome = useTerminalChrome("journal");
  const docDate = watch("invdate");
  const remarkShown = watch("remark");
  // display only - the totals above stay the form's own
  const debitShown = (Number(totalDebit) || 0).toFixed(2);
  const creditShown = (Number(totalCredit) || 0).toFixed(2);
  const diffShown = Math.abs(
    (Number(totalDebit) || 0) - (Number(totalCredit) || 0)
  ).toFixed(2);
  const balState =
    totalDebit == 0 && totalCredit == 0
      ? ""
      : totalDebit === totalCredit
      ? "si-balrow--ok"
      : "si-balrow--due";

  return (
    <div
      className="modal fade show si-term si-term--txn"
      data-si-theme={chrome.theme}
      style={{ display: "block" }}
      tabIndex="-1"
    >
      <div className="modal-dialog si-dialog">
        <div className="modal-content si-content">
          <form className="si-form" onSubmit={handleSubmit(handleFormSubmit)}>
            <div className="si-grid">
              <div className="si-left">
                {/* ============ COMMAND BAR ============ */}
                <TermCmdBar
                  chrome={chrome}
                  title="Journal Entry"
                  docNo={watch("no")}
                  state={
                    mode === "edit"
                      ? { key: "edit", label: "Editing" }
                      : { key: "new", label: "New" }
                  }
                  onBack={handleClose}
                />
                {/* entry no. is generated - the header shows it */}
                <input
                  type="text"
                  className="si-offscreen"
                  tabIndex={-1}
                  aria-hidden="true"
                  {...register("no")}
                  required
                  disabled
                />

                {/* ============ HEADER FIELDS ============ */}
                <section className="si-strip">
                  <div className="si-strip-row si-strip-row--auto">
                    <div className="si-fld">
                      <label>
                        Date <span className="si-req">*</span>
                      </label>
                      <Controller
                        control={control}
                        name="invdate"
                        render={({ field: { onChange, value } }) => (
                          <DatePicker
                            className="si-date"
                            value={value ? dayjs(value) : dayjs()}
                            format="DD-MM-YYYY"
                            onChange={(date) =>
                              onChange(date ? date.format("YYYY-MM-DD") : null)
                            } // Update on change
                          />
                        )}
                      />
                    </div>
                    <div className="si-fld si-fld--wide">
                      <label>Remark</label>
                      <input
                        type="text"
                        className="si-in"
                        placeholder="Note for this journal"
                        {...register(`remark`)}
                      />
                    </div>
                  </div>
                </section>

                {/* ============ LINES ============ */}
                <section className="si-lines">
                  <TermColumns chrome={chrome} columns={[]}>
                    <button
                      type="button"
                      className="si-iconbtn"
                      onClick={handleAddRow}
                    >
                      <Plus />
                      <span>Add line</span>
                    </button>
                  </TermColumns>

                  <div className="si-tablewrap">
                    <table className="si-table" style={{ minWidth: "720px" }}>
                      <thead>
                        <tr>
                          <th style={{ width: "280px" }}>
                            Ledger <span className="si-req">*</span>
                          </th>
                          <th className="n" style={{ width: "130px" }}>
                            Debit <span className="si-req">*</span>
                          </th>
                          <th className="n" style={{ width: "130px" }}>
                            Credit <span className="si-req">*</span>
                          </th>
                          <th>Narration</th>
                          <th style={{ width: "44px" }} aria-label="Line actions" />
                        </tr>
                      </thead>
                      <tbody>
                        {fields?.map((obj, index) => {
                          return (
                            <tr className="si-line" key={index}>
                              <td data-label="Ledger">
                                <Controller
                                  control={control}
                                  name={`items[${index}].ledger`}
                                  rules={{
                                    required: "Ledger is required",
                                    validate: (value) => {
                                      const selectedJournal = watch(
                                        "items"
                                      )?.map((row) => row.ledger);
                                      const isDuplicate =
                                        selectedJournal?.filter(
                                          (obj) => obj && obj === value
                                        )?.length > 1; // Exclude empty values
                                      return (
                                        !isDuplicate ||
                                        "Duplicate Ledger selected!"
                                      );
                                    },
                                  }}
                                  render={({
                                    field: { onChange, value },
                                    fieldState: { error },
                                  }) => (
                                    <>
                                      <Select
                                        classNamePrefix="react-select"
                                        className="si-itemsel"
                                        placeholder="Ledger"
                                        options={formatedLedger}
                                        value={formatedLedger?.find(
                                          (option) => option.value === value
                                        )}
                                        onChange={(selectedOption) =>
                                          onChange(selectedOption?.value || "")
                                        }
                                        menuPortalTarget={menuHost}
                                        menuPosition="fixed"
                                        styles={siSelectStyles}
                                      />
                                      {/* Required Field Error */}
                                      {error?.type === "required" && (
                                        <span className="si-err">
                                          {error.message}
                                        </span>
                                      )}
                                      {/* Duplicate Validation Error */}
                                      {error?.type === "validate" && (
                                        <span className="si-err">
                                          {error.message}
                                        </span>
                                      )}
                                    </>
                                  )}
                                />
                              </td>
                              <td className="n" data-label="Debit">
                                <input
                                  type="number"
                                  min="0"
                                  className="si-cellin"
                                  {...register(`items[${index}].debit`, {
                                    validate: (value) => {
                                      const credit = watch(
                                        `items[${index}].credit`
                                      );
                                      if (
                                        (value > 0 && credit > 0) ||
                                        (value == 0 && credit == 0)
                                      ) {
                                        return "Enter either Debit or Credit (not both/empty)";
                                      }
                                      return true;
                                    },
                                  })}
                                />
                                {errors.items?.[index]?.debit && (
                                  <span className="si-err">
                                    {errors.items[index].debit.message}
                                  </span>
                                )}
                              </td>
                              <td className="n" data-label="Credit">
                                <input
                                  type="number"
                                  min="0"
                                  className="si-cellin"
                                  {...register(`items[${index}].credit`, {
                                    validate: (value) => {
                                      const debit = watch(
                                        `items[${index}].debit`
                                      );
                                      if (
                                        (value > 0 && debit > 0) ||
                                        (value == 0 && debit == 0)
                                      ) {
                                        return "Enter either Debit or Credit (not both/empty)";
                                      }
                                      return true;
                                    },
                                  })}
                                />
                                {errors.items?.[index]?.credit && (
                                  <span className="si-err">
                                    {errors.items[index].credit.message}
                                  </span>
                                )}
                              </td>
                              <td data-label="Narration">
                                <input
                                  type="text"
                                  className="si-cellin si-cellin--text"
                                  placeholder="—"
                                  {...register(`items[${index}].narration`)}
                                />
                              </td>
                              <td>
                                <div className="si-rowacts">
                                  <Link
                                    to="#"
                                    className="si-rowbtn si-rowbtn--del confirm-text"
                                    title="Remove line"
                                    aria-label="Remove line"
                                    onClick={() => remove(index)}
                                  >
                                    <Trash2 />
                                  </Link>
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                    {fields?.length === 0 && (
                      <div className="si-empty">
                        <p className="big">No lines yet</p>
                        <p>Press Add line to start the journal.</p>
                      </div>
                    )}
                  </div>

                  <div className="si-lines-foot">
                    <span>
                      Lines <b>{fields.length}</b>
                    </span>
                    <span>
                      Debit <b>{debitShown}</b>
                    </span>
                    <span>
                      Credit <b>{creditShown}</b>
                    </span>
                  </div>
                </section>

                {/* ============ STATUS BAR ============ */}
                <TermStatusBar
                  context={[
                    remarkShown,
                    docDate ? dayjs(docDate).format("DD-MM-YYYY") : null,
                  ]}
                />
              </div>

              {/* ============ RAIL ============ */}
              <aside className="si-rail">
                <div className="si-rail-scroll">
                  <div className="si-card">
                    <div className="si-card-h">
                      <span>Journal</span>
                      <span className="r">
                        {docDate ? dayjs(docDate).format("DD-MM-YYYY") : ""}
                      </span>
                    </div>
                    <div className="si-party">
                      <div className="nm">{remarkShown || "No remark"}</div>
                      <div className="meta">{`Entry ${watch("no") || "—"}`}</div>
                    </div>
                  </div>

                  <div className="si-card">
                    <div className="si-card-h">Summary</div>
                    <div className="si-tot">
                      <div className="si-tr">
                        <span className="l">Lines</span>
                        <span className="v">{fields.length}</span>
                      </div>
                      <div className="si-tr">
                        <span className="l">Total debit</span>
                        <span className="v">{debitShown}</span>
                      </div>
                      <div className="si-tr">
                        <span className="l">Total credit</span>
                        <span className="v">{creditShown}</span>
                      </div>
                    </div>
                    <div className={`si-balrow ${balState}`}>
                      <span>
                        {balState === "si-balrow--due" ? "Difference" : "Balanced"}
                      </span>
                      <span className="v">{diffShown}</span>
                    </div>
                  </div>
                </div>

                {!loading && (
                  <div className="si-actions">
                    <button className="si-btn si-btn--primary" type="submit">
                      <Check />
                      <span>Submit</span>
                    </button>
                    <button
                      type="button"
                      className="si-btn si-btn--ghost"
                      onClick={resetmodal}
                    >
                      <RotateCcw />
                      <span>Reset</span>
                    </button>
                  </div>
                )}
              </aside>
            </div>
          </form>
        </div>
      </div>
      {/* react-select menus portal here so they inherit the .si-term tokens */}
      <div ref={setMenuHost} className="si-menu-host" />
    </div>
  );
};
export default JournalEntryModal;
